<ng-container *ngIf="displayMode == 'INPUT' else RoundedButtonTemplate">

  <ng-container *ngIf="property?.Combo?.length > 0 else InputTemplate">
    <select class="w-100 q-main-select" [ngClass]="[property.highlight ? 'q-danger' : '']" [(ngModel)]="property.Value">
      <option *ngFor="let option of property.Combo" [value]="option.Value">{{option.Key}}</option>
    </select>
  </ng-container>

  <ng-template #InputTemplate>
    <ng-container [ngSwitch]="type">
      <ng-container *ngSwitchCase="'STRING'">
        <input type="text" (blur)="property.highlight = false;" [ngClass]="[property.highlight ? 'q-danger' : '']" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="property.Value" />
      </ng-container>
      <ng-container *ngSwitchCase="'STRINGAREA'">        
        <textarea (blur)="property.highlight = false;" [ngClass]="[property.highlight ? 'q-danger' : '']" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="property.Value" id="id_txt{{uuid}}" name="name_txt{{uuid}}" rows="4" cols="50"></textarea>
      </ng-container>
      <ng-container *ngSwitchCase="'INT'">
        <input type="number" (blur)="property.highlight = false;" [ngClass]="[property.highlight ? 'q-danger' : '']" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="property.Value" />
      </ng-container>
      <ng-container *ngSwitchCase="'MONETARY'">
        <input type="number" step="0.01" (blur)="property.highlight = false;" [ngClass]="[property.highlight ? 'q-danger' : '']" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="property.Value" />
      </ng-container>
      <ng-container *ngSwitchCase="'BOOLEAN'">
        <span class="checkbox checbox-switch switch-primary w-100">
          <label for="{{uuid}}">
            <input type="checkbox" id="{{uuid}}" [(ngModel)]="property.Value" />
            <span></span>
          </label>
        </span>
      </ng-container>
      <ng-container *ngSwitchCase="'DATE'">
        <div class="w-100" style=" display: flex; flex-wrap: wrap;">
          <div class="q-date" [ngClass]="[ DateMinutesList?.length > 0 ? 'col-5-minus-8px px-0' : 'col']" style="min-width: 140px">
            <input type="date" max="9999-12-31" [id]="uuid" [ngModel]="dtValue | date:'yyyy-MM-dd'"
                   class="q-input-border pl-2"
                   (blur)="OnBlur($event.target.value)">
          </div>

          <ng-container *ngIf="DateMinutesList?.length > 0">
            <select class="q-main-select col-3 mx-auto"
                    style="min-width: 60px"
                    [ngModel]="property?.Value?.heures"
                    (change)="OnPropHourChange(property, $event.target.value, true)">
              <option *ngFor="let hour of [].constructor(24); let i = index" [value]="i < 10 ? '0' + i : i">{{i < 10 ? '0' + i : i}}</option>
            </select>

            <select class="q-main-select col-3"
                    style="min-width: 60px"
                    [ngModel]="property?.Value?.minutes"
                    (change)="OnPropMinutesChange(property, $event.target.value, true)">
              <option *ngFor="let minutes of DateMinutesList; let i = index" [value]="minutes">{{minutes}}</option>
            </select>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-template>
</ng-container>

<ng-template #RoundedButtonTemplate>
  <!--#region bouton générique-->
  <div [ngClass]="[property.highlight ? 'q-danger' : overrideBackgroundColor ? '' : 'q-dark-secondary', buttonCustomClass]" class="rounded-button ml-1 q-pointer"
       [style.minWidth.px]="type == 'DATE' ? 150 : 0"
       [style.position]="type == 'DATE' ? 'relative' : ''"
       placement="bottom bottom-left bottom-right auto"
       container="body"
       [autoClose]="'outside'"
       [ngbPopover]="f4"
       #p4="ngbPopover"
       (hidden)="PopoverClosed()"
       (click)="TypePopover = p4; PropPopover = property"
       [title]="property.Value | displayValue: property: type">
    <span>
      <i *ngIf="type == 'DATE'" class="far fa-clock mr-1"></i>
      <span [ngClass]="{ 'ml-3' : type == 'DATE'  && (property.Label || (property.Value | displayValue: property: type) != '- - - - - -' )}" class="q-bold">{{property.Label ? property.Label + ' : ' : ''}}{{property.Value | displayValue: property: type}}</span>
      <!--<span [ngClass]="{ 'ml-3' : type == 'DATE'}"> {{property.Value | displayValue: property: type}}</span>-->
    </span>
  </div>
  <!--#endregion-->
  <!--#region popovers spécifiques à chaque format de valeur-->
  <ng-template #f4>
    <!--#region popover générique pour les combos-->
    <ng-container *ngIf="property.Combo && property.Combo.length > 0 else DisplayPropertyWithoutCombo">
      <ng-container *ngFor="let combo of PropPopover?.Combo; let i = index">
        <div class="q-hover q-pointer px-2" (click)="OnChangeComboValue(PropPopover, combo.Value); PropPopover.highlight = false;">{{combo.Key}}</div>
      </ng-container>
    </ng-container>
    <!--#endregion-->
    <ng-template #DisplayPropertyWithoutCombo>
      <ng-container [ngSwitch]="type">
        <!--#region string-->
        <ng-container *ngSwitchCase="'STRING'">
          <ng-container *ngIf="!property.Combo || property.Combo.length < 1">
            <input type="text" (blur)="property.highlight = false;" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="property.Value" />
          </ng-container>
        </ng-container>
        <!--#endregion-->
        <!--#region string area-->
        <ng-container *ngSwitchCase="'STRINGAREA'">
          <ng-container *ngIf="!property.Combo || property.Combo.length < 1">            
            <textarea  (blur)="property.highlight = false;" [ngClass]="[property.highlight ? 'q-danger' : '']" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="property.Value" id="id_txt{{uuid}}" name="name_txt{{uuid}}" rows="4" cols="50"></textarea>
          </ng-container>
        </ng-container>
        <!--#endregion-->
        <!--#region entiers-->
        <ng-container *ngSwitchCase="'INT'">
          <input type="number" (blur)="property.highlight = false;" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="property.Value" />
        </ng-container>
        <!--#endregion-->
        <!--#region booléens-->
        <ng-container *ngSwitchCase="'BOOLEAN'">
          <div class="checkbox checbox-switch switch-primary">
            <label class="m-0">
              <input type="checkbox" [(ngModel)]="property.Value" />
              <span></span>
            </label>
          </div>
        </ng-container>
        <!--#endregion-->
        <!--#region monaitaires-->
        <ng-container *ngSwitchCase="'MONETARY'">
          <input type="number" step="0.01" (blur)="property.highlight = false;" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="property.Value" />
        </ng-container>
        <!--#endregion-->
        <!--#region date-->
        <ng-container *ngSwitchCase="'DATE'">
          <ngb-datepicker #d [startDate]="{year:PropPopover?.Value?.Year, month:PropPopover?.Value?.Month, day:PropPopover?.Value?.Day}" [ngModel]="{year:PropPopover?.Value?.Year, month:PropPopover?.Value?.Month, day:PropPopover?.Value?.Day}" (ngModelChange)="datePropChange(PropPopover, $event); PropPopover.highlight = false;"></ngb-datepicker>
          <div *ngIf="DateMinutesList?.length > 0" class="row">
            <div class="col mt-2 pr-1">
              <select class="q-main-select w-100" [ngModel]="PropPopover?.Value?.heures" (change)="OnPropHourChange(PropPopover, $event.target.value, false)">
                <option *ngFor="let hour of [].constructor(24); let i = index" [value]="i < 10 ? '0' + i : i">{{i < 10 ? '0' + i : i}}</option>
              </select>
            </div>
            <div class="col mt-2 pl-1">
              <select class="q-main-select w-100" [ngModel]="PropPopover?.Value?.minutes" (change)="OnPropMinutesChange(PropPopover, $event.target.value, false)">
                <option *ngFor="let minutes of DateMinutesList; let i = index" [value]="minutes">{{minutes}}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <button class="q-btn q-white col ml-3 mr-1 mt-2" (click)="TypePopover.close(); SetToday(PropPopover)"><i class="far fa-calendar-check q-c-main mr-1"></i>Aujourd’hui</button>
            <button class="q-btn q-white col ml-1 mr-3 mt-2" (click)="TypePopover.close(); OnCleanDate(PropPopover);"><i class="fas fa-trash q-c-danger mr-1"></i>Retirer</button>                    
          </div>
        </ng-container>
        <!--#endregion-->
      </ng-container>
    </ng-template>
  </ng-template>
  <!--#endregion-->
</ng-template>
